﻿export default class ListFieldsControl {
    constructor(options) {
        /* Input Parameters */
        this.objectType = options.objectType;
        this.objectId = options.objectId;
        this.localization = options.localization;
        this.fieldsFilterItem = options.fieldsFilterItem;
        this.fieldsTreeItem = options.fieldsTreeItem;
        this.fieldsDefinitionItem = options.fieldsDefinitionItem;

        /* Definition Field Properties */
        this.fieldTitle = 'field-title';
        this.fieldName = 'field-name';
        this.fieldEntityFieldName = 'field-entity-field-name';
        this.fieldDescription = 'field-description';
        this.fieldDisplayFormat = 'field-display-format';
        this.fieldWidth = 'field-width';
        this.fieldHidden = 'field-hidden';
        this.fieldSortable = 'field-sortable';
        this.fieldGroupable = 'field-groupable';
        this.fieldControlType = 'field-control-type';
        this.fieldPlatforms = 'field-control-platforms';
        this.fieldHtmlAttributes = 'field-html-attributes';
        this.fieldHeaderHtmlAttributes = 'field-header-html-attributes';

        /* Control Properties */
        this.index = 3;
        this.isTreeInitialized = false;
        this.selectedField = null;
        this.selectedFieldShown = false;
        this.selectedFieldInitialized = false;

        this.actionSubFormIdPkVal = 'IdListFieldTarget';
        this.actionSubFormIdForm = 'IdFormListFieldTarget';

        this._initControl();
    }

    /* Public Methods */

    saveItems() {
        this._saveDetails();
        this._saveFieldItems();
    }

    getEntityFields() {
        let fieldParentNode = $('#' + this.fieldsTreeItem).data("kendoTreeView").dataSource.data().filter(action => { return action.id == 1 })[0];

        let fieldNodes = fieldParentNode.children.data();

        let fieldData = [];

        fieldNodes.forEach(fieldNode => {
            fieldData.push(fieldNode.storedItem);
        });

        return fieldData;
    }

    getFields() {
        let fieldParentNode = $('#' + this.fieldsTreeItem).data("kendoTreeView").dataSource.data().filter(action => { return action.id == 1 })[0];

        let fieldNodes = fieldParentNode.children.data();

        let fieldData = [];

        fieldNodes.forEach(fieldNode => {
            if (fieldNode.checked) {
                fieldData.push(fieldNode.storedItem);
            }
        });

        return fieldData;
    }

    getResource(name) {
        if (this.localization[name] != null && this.localization[name].trim() != '') {
            return this.localization[name];
        }

        return name;
    }

    /* Private Methods */

    _saveDetails() {
        if (this.selectedField != null) {
            switch (this.selectedField.type) {
                case 'field': this._saveFieldDetails();
                    break;
                default: break;
            }
        }
    }

    _saveFieldDetails() {
        let item = {};
        item.Label = $('#' + this.fieldName).val();
        item.Description = $('#' + this.fieldDescription).val();
        item.DisplayFormat = $('#' + this.fieldDisplayFormat).val();

        let width = $('#' + this.fieldWidth).val();

        if (width != null && width != '') {
            item.Width = new Number(width);
        }

        item.Hidden = $('#' + this.fieldHidden).data('kendoSwitch').check();
        item.Sortable = $('#' + this.fieldSortable).data('kendoSwitch').check();
        item.Groupable = $('#' + this.fieldGroupable).data('kendoSwitch').check();

        let controlType = $('#' + this.fieldControlType).data('kendoComboBox').value();

        if (controlType != null && controlType != '') {
            item.ControlType = controlType;
        } else {
            item.ControlType = 0;
        }

        let platforms = this._getPlatform($('#' + this.fieldPlatforms).data('kendoMultiSelect'));
        item.Platforms = platforms;

        item.DataType = this.selectedField.storedItem.DataType;
        item.DataSubType = this.selectedField.storedItem.DataSubType;
        item.SpecialFieldType = this.selectedField.storedItem.SpecialFieldType;
        item.FieldName = this.selectedField.storedItem.FieldName;
        item.IdEntityField = this.selectedField.storedItem.IdEntityField;
        item.Id = this.selectedField.storedItem.Id;
        this.selectedField.storedItem = item;
        // TO DO save attributes
    }

    _saveFieldItems() {
        let fieldParentNode = $('#' + this.fieldsTreeItem).data("kendoTreeView").dataSource.data().filter(action => { return action.id == 1 })[0];

        let fieldNodes = fieldParentNode.children.data();

        let fieldData = [];

        fieldNodes.forEach(fieldNode => {
            if (fieldNode.checked) {
                fieldData.push(fieldNode.storedItem);
            }
        });

        let data = {
            fields: fieldData,
            id: this.objectId
        }

        let saveFieldsUrl = rootUrl + 'EntityList/SaveFields'

        $.ajax({
            type: "POST",
            url: saveFieldsUrl,
            async: true,
            data: JSON.stringify(data),
            contentType: "application/json; charset=utf-8",
            success: (result) => {
                this._refreshControl();
            },
            error: (e) => {
                toastr.error(this._getResource('SaveError'));
            }
        });
    }

    _refreshControl() {
        this.isTreeInitialized = false;
        let parent = $('#fields-tree-control').parent();
        $('#fields-tree-control').remove();
        parent.append('<div id="fields-tree-control" style="border:none !important; position: absolute; padding-top: 0; width: 100%; overflow-x: clip;"></div>');
        this._initTree();
    }

    _initControl() {
        this._initTree();
        this._initEvents();
    }

    _initTree() {
        if (!this.isTreeInitialized) {
            let fieldNode = {
                index: 1,
                isParent: true,
                displayText: this._getResource('Fields'),
                type: 'parent_fields',
                items: []
            };

            let dataSource = new kendo.data.HierarchicalDataSource({
                data: [fieldNode], schema: {
                    model: {
                        id: "index",
                        children: "items"
                    }
                }
            });

            $('#' + this.fieldsTreeItem).kendoTreeView({
                template: (evt) => {
                    let item = evt.item;
                    let templ = '';

                    if (item.storedItem != null && item.storedItem.InvalidProperties != null && item.storedItem.InvalidProperties.length > 0) {
                        let errorTitle = '';
                        $('#tabFieldsSel').addClass('list-fields-tab-error');

                        item.storedItem.InvalidProperties.forEach(error => {
                            errorTitle += error.Message + '\n';
                        });

                        templ = '<div title="' + errorTitle + '"><span class="error-tree-node field-display-text' + (item.isParent ? ' tree-parent-field' : '') + '">' + item.displayText + '<i class="ml-2 fal fa-exclamation-circle" style="font-weight: bold;"></i></span><span class="field-display-details">' + (item.details != null ? item.details : '') + '</span></div>';
                    } else {
                        templ = '<div><span class="field-display-text' + (item.isParent ? ' tree-parent-field' : '') + '">' + item.displayText + '</span><span class="field-display-details">' + (item.details != null ? item.details : '') + '</span></div>';
                    }

                    return templ;
                },
                checkboxes: {
                    name: 'checked'
                },
                dragAndDrop: true,
                dragend: (e) => {
                    this._filterTree();
                },
                loadOnDemand: false,
                dataSource: dataSource,
                dataTextField: "displayText",
                dataValueField: "index",
                select: (e) => {
                    this._selectField(e);
                },
                check: (e) => {
                    let checked = $('#' + this.fieldsTreeItem).data("kendoTreeView").dataItem(e.node);
                    if (checked.checked) {
                        checked.storedItem.Label = this._handleInitialFieldName(checked.storedItem.Label, checked.storedItem.FieldName);
                        checked.set('displayText', checked.storedItem.Label);
                        checked.set('details', ' (' + checked.storedItem.FieldName + ')');
                    }
                    loadPreview();
                }
            });
            $('.tree-parent-field').closest('.k-in').siblings('.k-checkbox-wrapper').hide();
            this._loadItems();
            this.isTreeInitialized = true;
        }
    }

    _setPlatform(ctl, value) {
        var val = null;
        if (value != null) {
            val = value.split(",");
        }
        else {
            val = [];
            val.push("ALL");
        }
        ctl.value(val);
    }
    _getPlatform(ctl) {
        if (ctl == null) {
            return null;
        }
        var val = ctl.value();
        if (val == null || val.length == 0) {
            return null;
        }
        if (val == "ALL") {
            return null;
        }

        return val.join(",");
    }
    _platform_onChange(e) {
        var ctl = e.sender;
        var val = ctl.value();
        var all = false;
        if (val != null && (val.length == 0 || val[val.length - 1] == "ALL")) {
            all = true;
        }
        if (val == null) {
            all = true;
        }
        if (all) {
            var data = ctl.dataSource.data();
            for (var i = 0; i < data.length; i++) {
                if (data[i].Id == "ALL") {
                    ctl.value(["ALL"]);
                    break;
                }
            }
        }
        else {
            //daca exista All trebuie sa il scot. probabil nu este ultimul (caz tratat mai sus)
            var newVal = [];
            var found = false;
            for (var i = 0; i < val.length; i++) {
                if (val[i] == "ALL") {
                    found = true;
                }
                else {
                    newVal.push(val[i]);
                }
            }
            if (found) {
                ctl.value(newVal);
            }
        }
    }

    _filterTree() {
        let searchFilter = {
            field: "displayText",
            operator: "contains",
            value: $('#' + this.fieldsFilterItem).val()
        };

        $('#' + this.fieldsTreeItem).data("kendoTreeView").dataSource.filter(searchFilter);
        $('.tree-parent-field').closest('.k-in').siblings('.k-checkbox-wrapper').hide();
    }

    _selectField(item) {
        $('#' + this.fieldsTreeItem).focus();
        this._selectNode(item.node);
    }

    _selectNode(node) {
        this._saveDetails();
        loadPreview();
        let selectedItem = $('#' + this.fieldsTreeItem).data("kendoTreeView").dataItem(node);
        this.selectedField = selectedItem;
        this.selectedFieldShown = true;

        switch (selectedItem.type) {
            case 'field': this._selectFieldNode(selectedItem);
                break;
            default: break;
        }
    }

    _selectFieldNode(item) {
        $('#' + this.fieldsDefinitionItem)[0].innerHTML = this._getFieldDefinitionTemplate();

        $('#' + this.fieldTitle)[0].innerHTML = item.storedItem.Label;
        $('#' + this.fieldName).val(this._handleInitialFieldName(item.storedItem.Label, item.storedItem.FieldName));
        $('#' + this.fieldEntityFieldName).val(item.storedItem.FieldName);
        $('#' + this.fieldDescription).val(item.storedItem.Description);
        $('#' + this.fieldDisplayFormat).val(item.storedItem.DisplayFormat);
        $('#' + this.fieldWidth).val(item.storedItem.Width);

        $('#' + this.fieldDescription).on('focusout', () => {
            this._saveDetails();
            loadPreview();
        });

        $('#' + this.fieldDisplayFormat).on('focusout', () => {
            this._saveDetails();
            loadPreview();
        });

        $('#' + this.fieldWidth).on('focusout', () => {
            this._saveDetails();
            loadPreview();
        });

        $("#" + this.fieldHidden).kendoSwitch({
            messages: {
                checked: this._getResource('SWITCH_ON'),
                unchecked: this._getResource('SWITCH_OFF')
            },
            checked: item.storedItem.Hidden,
            change: (e) => {
                this._saveDetails();
                loadPreview();
            }
        });

        $("#" + this.fieldSortable).kendoSwitch({
            messages: {
                checked: this._getResource('SWITCH_ON'),
                unchecked: this._getResource('SWITCH_OFF')
            },
            checked: item.storedItem.Sortable,
            change: (e) => {
                this._saveDetails();
                loadPreview();
            }
        });

        $("#" + this.fieldGroupable).kendoSwitch({
            messages: {
                checked: this._getResource('SWITCH_ON'),
                unchecked: this._getResource('SWITCH_OFF')
            },
            checked: item.storedItem.Groupable,
            change: (e) => {
                this._saveDetails();
                loadPreview();
            }
        });

        $('#' + this.fieldControlType).kendoComboBox({
            dataTextField: 'Name',
            dataValueField: 'Id',
            filter: 'contains',
            suggest: true,
            ignoreCase: true,
            //dataSource: [{
            //    Id: 0,
            //    Name: 'Default'
            //}, {
            //    Id: 1,
            //    Name: 'Content'
            //}],
            dataSource: {
                serverFiltering: false,
                transport: {
                    read: {
                        dataType: 'json',
                        url: () => {
                            return rootURL + 'EntityList/GetEntityListFieldControlTypes?dataType=' + this.selectedField.storedItem.DataType + '&dataSubType=' + this.selectedField.storedItem.DataSubType;
                        }
                    }
                }
            },
            change: (e) => {
                this._saveDetails();
                loadPreview();
            }
        });

        $('#' + this.fieldControlType).data('kendoComboBox').value(item.storedItem.ControlType);

        $('#' + this.fieldPlatforms).kendoMultiSelect({
            dataTextField: 'Name',
            dataValueField: 'Id',
            filter: 'contains',
            suggest: true,
            ignoreCase: true,
            dataSource: {
                serverFiltering: false,
                transport: {
                    read: {
                        dataType: 'json',
                        url: () => {
                            return rootURL + 'EntityList/GetPlatforms';
                        }
                    }
                }
            },
            change: (e) => {
                this._platform_onChange(e);
                this.saveDetails();
                loadPreview();
            },
            dataBound: (e) => {
                if (e.sender.dataSource.data().length == 1 && (e.sender.value() == null || (e.sender.value().trim != null && e.sender.value().trim() == ''))) {
                    e.sender.value(e.sender.dataSource.data()[0].Id);
                }
            }
        });

        if ($('#' + this.fieldPlatforms).data('kendoMultiSelect') != null) {
            this._setPlatform($('#' + this.fieldPlatforms).data('kendoMultiSelect'), item.storedItem.Platforms);
        }


        $('#' + this.fieldName).on('focusout', () => {
            $('#' + this.fieldTitle)[0].innerHTML = $('#' + this.fieldName).val();
            this._handleFieldName($('#' + this.fieldName).val());
            this._saveDetails();
            loadPreview();
        });

        this._validateField(item.storedItem);
    }

    _handleInitialFieldName(label, fieldName) {
        if (fieldName == label || label == null) {
            let tuples = fieldName.toLowerCase().replaceAll('id_z_', '').replaceAll('id_d_', '').split('_');
            let processedTuples = [];

            tuples.forEach(tuple => {
                let preprocessed = tuple.trim();
                let processed = preprocessed.charAt(0).toUpperCase() + preprocessed.slice(1);
                processedTuples.push(processed);
            });

            return processedTuples.join(' ');

        } else {
            return label;
        }
    }

    _loadItems() {
        this._loadFields();
    }

    _loadFields() {
        let getAllFieldsUrl = rootUrl + "EntityList/GetAllFields";
        let data = {
            id: this.objectId
        };

        $.ajax({
            type: "POST",
            url: getAllFieldsUrl,
            async: true,
            data: JSON.stringify(data),
            contentType: "application/json; charset=utf-8",
            success: (result) => {
                if (result != null && (result.Error == null || result.Error == '')) {
                    let fieldsContainer = JSON.parse(result.jsonEntity);
                    this._handleEntityListValidityMessage(fieldsContainer.InvalidProperties);
                    let fields = fieldsContainer.Fields;
                    this._initFields(fields);
                    notifyFieldsLoaded();
                } else if (result == null || result.Error == null) {
                    toastr.error(this._getResource('GetAllFieldsError'));
                } else {
                    toastr.error(result.Error);
                }
            },
            error: (e) => {
                toastr.error(this._getResource('GetAllFieldsError'));
            }
        });
    }

    _handleEntityListValidityMessage(invalidProperties) {
        if (invalidProperties != null && invalidProperties.length > 0) {
            let errorTemplate = '';
            invalidProperties.forEach(invalidProperty => {
                errorTemplate += '&#9632;' + (invalidProperty.PropertyName != null && invalidProperty.PropertyName != '' ? ('<strong>' + invalidProperty.PropertyName + ':</strong>' + ' ') : '') + ' ' + invalidProperty.Message + '<br>';

            });
            $('#entity-list-errors-container')[0].innerHTML = errorTemplate;
            $('#entity-list-validation-wrapper').show();
        } else {
            $('#entity-list-validation-wrapper').hide();
        }
    }

    _initFields(fields) {
        let fieldsNodeUid = $('#' + this.fieldsTreeItem).data("kendoTreeView").dataSource.data().filter(field => { return field.id == 1 })[0].uid;
        let fieldsNode = $('#' + this.fieldsTreeItem).data("kendoTreeView").findByUid(fieldsNodeUid);

        fields.forEach(field => {
            let details = '';
            if (field.Label != null && field.Label != '' && field.Label != field.FieldName) {
                details = ' (' + field.FieldName + ')';
            }

            $('#' + this.fieldsTreeItem).data("kendoTreeView").append({
                storedItem: field,
                index: ++this.index,
                displayText: field.Label != null && field.Label != '' && field.Label != field.FieldName ? field.Label : field.FieldName,
                checked: field.Checked,
                details: details,
                items: [],
                type: 'field'
            }, fieldsNode);
        });
    }

    _initEvents() {
        $('#' + this.fieldsFilterItem).on('input', (evt) => {
            this._filterTree();
        });
    }

    _handleFieldName(fieldName) {
        this.selectedField.set('displayText', fieldName);
        this.selectedField.storedItem.Label = fieldName;
        this.selectedField.set('details', ' (' + this.selectedField.storedItem.FieldName + ')');
    }

    _validateField(item) {
        if (item.InvalidProperties != null && item.InvalidProperties.length > 0) {
            item.InvalidProperties.forEach(property => {
                if ($('#' + property.PropertyName + '-validation').length == 0) {
                    alert(property.Message);
                }
                else {
                    $('#' + property.PropertyName + '-validation')[0].innerHTML = property.Message;
                }                
            });
        }
    }

    /* Templates */

    _getFieldDefinitionTemplate() {
        let template = `<div class="form-row">
                            <div class="col-sm-12 d-flex align-items-center pb-2 border-bottom mb-3 ">
                                <h1 class="subheader-title ml-1 ml-lg-0 mt-2" id="` + this.fieldTitle + `" style="font-size: 1rem;"></h1>
                            </div>
                        </div>
                        <div class="form-row" style="max-height: calc(100% - 3.3rem); overflow: auto; overflow-x: hidden;">
                            <div class="field-definition-content col-12">
                                <div class="form-row">
                                    <div class="col-sm-6 mb-3">
                                        <div class="form-group">
                                            <label class="form-label">` + this._getResource('FieldName') + `</label>
                                            <input type="text" id="` + this.fieldName + `" class="form-control" autocomplete="off"/>
                                            <span id="Label-validation" class="field-error-message"></span>
                                        </div>
                                    </div>
                                    <div class="col-sm-6 mb-3">
                                        <div class="form-group">
                                            <label class="form-label">` + this._getResource('EntityFieldName') + `</label>
                                            <input type="text" id="` + this.fieldEntityFieldName + `" class="form-control" autocomplete="off" readonly/>
                                            <span id="FieldName-validation" class="field-error-message"></span>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-row">
                                    <div class="col-sm-12 mb-3">
                                        <div class="form-group">
                                            <label class="form-label">` + this._getResource('Description') + `</label>
                                            <textarea id="` + this.fieldDescription + `" class="form-control" style="height: 5rem;"></textarea>
                                            <span id="Description-validation" class="field-error-message"></span>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-row">
                                    <div class="col-sm-6 mb-3">
                                        <div class="form-group">
                                            <label class="form-label" help-key="EntityList.DisplayFormat">` + this._getResource('DisplayFormat') + `</label>
                                            <input type="text" id="` + this.fieldDisplayFormat + `" class="form-control" autocomplete="off"/>
                                            <span id="DisplayFormat-validation" class="field-error-message"></span>
                                        </div>
                                    </div>
                                    <div class="col-sm-6 mb-3">
                                        <div class="form-group">
                                            <label class="form-label">` + this._getResource('Width') + `</label>
                                            <input type="number" id="` + this.fieldWidth + `" class="form-control" autocomplete="off"/>
                                            <span id="Width-validation" class="field-error-message"></span>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-row">
                                    <div class="col-sm-4 mb-3" style="align-content: center; display: flex; flex-wrap: wrap;">
                                        <div class="form-group" style="display: flex; flex-direction: row-reverse;">
                                            <label class="form-label" style="margin-left: 5px;">` + this._getResource('Hidden') + `</label>
                                            <div id="` + this.fieldHidden + `"></div>
                                            <span id="Hidden-validation" class="field-error-message"></span>
                                        </div>
                                    </div>
                                    <div class="col-sm-4 mb-3" style="align-content: center; display: flex; flex-wrap: wrap;">
                                        <div class="form-group" style="display: flex; flex-direction: row-reverse;">
                                            <label class="form-label" style="margin-left: 5px;">` + this._getResource('Sortable') + `</label>
                                            <div id="` + this.fieldSortable + `"></div>
                                            <span id="Sortable-validation" class="field-error-message"></span>
                                        </div>
                                    </div>
                                    <div class="col-sm-4 mb-3" style="align-content: center; display: flex; flex-wrap: wrap;">
                                        <div class="form-group" style="display: flex; flex-direction: row-reverse;">
                                            <label class="form-label" style="margin-left: 5px;">` + this._getResource('Groupable') + `</label>
                                            <div id="` + this.fieldGroupable + `"></div>
                                            <span id="Groupable-validation" class="field-error-message"></span>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-row">
                                    <div class="col-sm-6 mb-3">
                                        <div class="form-group">
                                            <label class="form-label">` + this._getResource('ControlType') + `</label>
                                            <div id="` + this.fieldControlType + `" class="form-control"></div>
                                            <span id="ControlType-validation" class="field-error-message"></span>
                                        </div>
                                    </div>
                                    <div class="col-sm-6 mb-3">
                                        <div class="form-group" style="margin-bottom: 0; margin-top: 1.65rem;">
                                            <button id="` + this.fieldHtmlAttributes + `" class="btn btn-primary ml-2" title="` + this._getResource('HtmlAttributes') + `" type="button">` + this._getResource('HtmlAttributes') + `</button>
                                            <button id="` + this.fieldHeaderHtmlAttributes + `" class="btn btn-primary ml-2" title="` + this._getResource('HeaderHtmlAttributes') + `" type="button">` + this._getResource('HeaderHtmlAttributes') + `</button>
                                        </div>
                                        <span id="HtmlAttributes-validation" class="field-error-message"></span>
                                        <span id="HeaderHtmlAttributes-validation" class="field-error-message"></span>
                                    </div>
                                </div>
                                <div class="form-row">
                                    <div class="col-sm-12 mb-3">
                                        <div class="form-group">
                                            <label class="form-label">` + this._getResource('Platforms') + `</label>
                                            <div id="` + this.fieldPlatforms + `" class="form-control"></div>
                                            <span id="Platforms-validation" class="field-error-message"></span>
                                        </div>
                                    </div>                                    
                                </div>
                            </div>
                        </div>`;

        return template;
    }

    /* Resources */

    _getResource(name) {
        if (this.localization[name] != null && this.localization[name].trim() != '') {
            return this.localization[name];
        }

        return name;
    }
}